export const getApplicationSettings = () => ({
  url: '/application-settings'
})
